var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard__container"},[_c('div',{staticClass:"mb-5",style:({ textAlign: 'center', marginTop: '20px' })},[_c('h2',{staticClass:"mb-1 font-bold"},[_vm._v("Video Creator Wizard")]),_c('p',[_vm._v("Here are your created videos")])]),_c('section',{staticClass:"bg-white container p-5"},[_vm._v(" No Videos created... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }